// --- Initial States for Resetting ---
// Default objects used to reset persistent state.

export const initialBudgetNeeds = { rent: '', utilities: '', studentLoan: '', carPayment: '', insurance: '', subscriptions: '' };
export const initialBudgetWants = { groceries: '', restaurants: '', gas: '', entertainment: '', shopping: '' };
export const initialBudgetSavings = { emergency: '', investing: '', other: '' };

export const initialBudgetData = {
  salary: '',
  location: 'Other', 
  takeHome: 0,
  needs: initialBudgetNeeds,
  wants: initialBudgetWants,
  savings: initialBudgetSavings,
};

export const initialResumeReports = {
  jobDescription: '',
  resume: '',
  reportCard: null,
  longevityReport: null,
};

export const initialUserProfile = {
  email: '',
  isCandidate: true, // Replaces B2C isStudent flag

  // --- Career Archetype Data ---
  careerArchetype: null, 
  
  // --- Enterprise B2B Telemetry ---
  vciScore: 0,
  readinessTier: 'Tier 1: Baseline',
  verifiedTraits: [],
  tenantConfig: null,

  careerTrack: null,
  verifiedCompetencies: [], // Formerly badges
  telemetrySignatures: [], // Formerly awardedActions
  lastLoginDate: null, // dailyLoginStreak permanently deprecated

  // --- Centralized Mastery Logic ---
  completedModules: {}, 
};